import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';

import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';
import { EntityService } from 'src/app/_core/entity.service';
import { MatDialog } from '@angular/material/dialog';
import { ExternalPayDialogComponent } from 'src/app/dialogs/external-pay-dialog/external-pay-dialog.component';
import { CardpointPayDialogComponent } from 'src/app/dialogs/cardpoint-pay-dialog/cardpoint-pay-dialog.component';
import { HeartlandPayDialogComponent } from 'src/app/dialogs/heartland-pay-dialog/heartland-pay-dialog.component';
import { StripePayDialogComponent } from 'src/app/dialogs/stripe-pay-dialog/stripe-pay-dialog.component';
import { AuthorizenetPayDialogComponent } from 'src/app/dialogs/authorizenet-pay-dialog/authorizenet-pay-dialog.component';
import { AdyenDialogComponent } from 'src/app/dialogs/adyen-dialog/adyen-dialog.component';
import { NavepxDialogComponent } from 'src/app/dialogs/navepx-dialog/navepx-dialog.component';
import { BraintreeDialogComponent } from '../dialogs/braintree-dialog/braintree-dialog.component';
import { KashcashDialogComponent } from '../dialogs/kashcash-dialog/kashcash-dialog.component';
import {MagensaPayDialogComponent} from "../dialogs/magensa-pay-dialog/magensa-pay-dialog.component";

import * as _ from 'lodash';
import {firstValueFrom} from "rxjs";


declare const $: any;
interface ApplePayPaymentRequest {
    countryCode: string;
    currencyCode: string;
    merchantCapabilities: string[];
    supportedNetworks: string[];
    total: ApplePayLineItem;
}

interface ApplePayLineItem {
    label: string;
    type: string;
    amount: string;
}

declare const ApplePaySession: any; // Declare ApplePaySession as any

// Google Pay Variables
declare var google: any;

const baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
};

const allowedGoogleCardNetworks = ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"];
const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];
const baseCardPaymentMethod = {
        type: 'CARD',
        parameters: {
        allowedAuthMethods: allowedCardAuthMethods,
        allowedCardNetworks: allowedGoogleCardNetworks
    }
};

@Injectable({
	providedIn: 'root'
})
export class ExpayService {
    public appConfig = environment.appConfig;
    public paymentsClient: any;

	constructor(
		public dialog: MatDialog,
		public http: HttpClient,
		public decimalPipe: DecimalPipe,
		public appService: AppService,
		public entityService: EntityService,
	) { }

	showCreditGuardDialog(res) {
		const args: any = this.appService.getURLParams({ search: `?${res.paymentUrl.split('?')[1]}` });
		const data: any = { redirectURL: res.paymentUrl, provider: 'CreditGuard' };
		// Needed to display X button in ExternalPayDialogComponent
		if (!!res.addToWallet) data.addToWallet = res.addToWallet;

		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(ExternalPayDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				data,
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed()
			.subscribe(result => {
				const mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve({ transactionId: args.txId, mode, saveToWallet: result.saveToWallet });
						break;
					case "error":
						reject({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: this.appService.translate("SERVER_MESSAGES.CREDIT_GUARD_EX_ERROR"),
							serverError: {}
						});
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	showStripeDialog(parsedPayment, args) {
		let $storage = this.appService.$storage;
		let account = _.find($storage.paymentAccounts, { _id: parsedPayment.account });
		let secret = args.providerTransactionSecret
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(StripePayDialogComponent, {
				//panelClass: 'full',
				direction: this.appService.direction,
				maxHeight: '100vh',
				data: {
					account: account,
					secret: secret,
					total: parsedPayment.amount / 100
				},
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve({ transactionId: result.transactionId });
						break;
					case "error":
						reject({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: this.appService.translate("SERVER_MESSAGES.CREDIT_GUARD_EX_ERROR"),
							serverError: {}
						});
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	showMeshulamDialog(res) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(ExternalPayDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				data: { redirectURL: res.paymentUrl, provider:'Meshulam' },
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve(res);
						break;
					case "error":
						reject({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: this.appService.translate("SERVER_MESSAGES.CREDIT_GUARD_EX_ERROR"),
							serverError: {}
						});
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	showExPayDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(ExternalPayDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				data: { redirectURL: args.redirectUrl },
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result != undefined) {
					if (_.get(result, 'HostedPaymentStatus') == 'Cancelled') reject({ type: "CANCELED" });
					else resolve(result);
				} else {
					reject({ type: "CANCELED" });
				}
			});
		});
	}

	async showCardPointDialog(parsedPayment, accountSetup) {
		let $storage = this.appService.$storage;
		let account = _.find($storage.paymentAccounts, { _id: parsedPayment.account });
		let paymentUrl = `${account.iframeUrl}?useexpiry=true&usecvv=true&invalidcreditcardevent=true&invalidcvvevent=true&invalidexpiryevent=true&tokenizewheninactive=true&inactivityto=2000&css=`;
		paymentUrl += encodeURI(`body, input, select {font-family: sans-serif; box-sizing:border-box}.error{color:red;}input, select{font-size:16px;height:30px;margin: 5px 0 15px;border: 1px solid rgba(0,0,0,0.12);border-radius: 4px;}input{}select{width:83px}form {margin: 0 auto; width: 200px;}  label{font-size:1em}`);

		await this.initMobileWalletScripts().catch((err) => {});

		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(CardpointPayDialogComponent, {
				panelClass: 'fullscreen-dialog',
				direction: this.appService.direction,
				data: { redirectURL: paymentUrl, type: 'CardPoint', total:parsedPayment.amount / 100, accountSetup: accountSetup },
				//maxWidth:'90vw',

				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve(result.data);
						break;
					/*case "error":
						reject({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: this.appService.translate("SERVER_MESSAGES.CREDIT_GUARD_EX_ERROR"),
							serverError: {}
						});
						break;*/
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	showHeartLandDialog(parsedPayment) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(HeartlandPayDialogComponent, {
				//panelClass: 'full',
				direction: this.appService.direction,
				data: { merchantNumber: parsedPayment.merchantNumber, total:parsedPayment.amount / 100 },
				maxWidth:'90vw',
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve(result.data);
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	showKashcashDialog(parsedPayment, setup) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(KashcashDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				data: {
					parsedPayment,
					setup
				},
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						_.assignIn(parsedPayment, {providerTransactionId: setup.providerTransactionId, paymentProcessId: setup.paymentProcess});
						resolve(parsedPayment);
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	showAuthorizeNetDialog(parsedPayment, args) {
		const $storage = this.appService.$storage;
		const account = _.find($storage.paymentAccounts, { _id: parsedPayment.account });
		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(AuthorizenetPayDialogComponent, {
				//panelClass: 'full',
				direction: this.appService.direction,
				maxWidth: '90vw',
				data: {
					account: account,
					token: args.token,
					total: parsedPayment.amount / 100,
                    iframeUrl: account.iframeUrl,
				},
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve({ transactionId: result.transactionId, billTo: result.billTo });
						break;
					case "error":
						reject({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: this.appService.translate("SERVER_MESSAGES.CREDIT_GUARD_EX_ERROR"),
							serverError: {}
						});
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	showAdyenDialog(parsedPayment, args, httpArgs?) {
		const $storage = this.appService.$storage;
		const account = _.find($storage.paymentAccounts, { _id: parsedPayment.account });
        const hasApplePayConfig = _.get(args, 'clientConfiguration.paymentMethodsConfiguration.applepay', null);
        const surcharges = args.surcharges;
		if (hasApplePayConfig && surcharges) {
            const showApplePayButton = this.appService.platformService.SAFARI;

            if (showApplePayButton) {
                const applePaySurcharge = surcharges['applepay'] || surcharges['other'] || 0;
                if (args.clientConfiguration?.paymentMethodsConfiguration?.applepay?.amount?.value) args.clientConfiguration.paymentMethodsConfiguration.applepay.amount.value += applePaySurcharge;
            } else {
                // Disable Apple Pay for Chrome
                if (args.clientConfiguration.paymentMethodsConfiguration.applepay) delete args.clientConfiguration.paymentMethodsConfiguration.applepay;
            }

            const paymentMethods = sortPaymentMethods(args.clientConfiguration.paymentMethodsResponse.paymentMethods, showApplePayButton);
            if (paymentMethods?.length) args.clientConfiguration.paymentMethodsResponse.paymentMethods = paymentMethods;
        }
		let isAddToWallet = parsedPayment.isAddToWallet;

		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(AdyenDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				//axWidth: '90vw',
				data: {
					account,
					args,
					httpArgs,
					parsedPayment,
					isProduction: this.appService.isProduction,
					isAddToWallet: isAddToWallet
				},
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				if (isAddToWallet) resolve(result);
				else {
					let mode = _.get(result, 'mode');
					switch (mode) {
						case "payment":
							resolve(result.payment);
							break;
						case "success":
							resolve(result.data);
							break;
						case "error":
							reject(result.error);
							break;
						default:
							reject({type: "CANCELED"});
					}
				}
			});
		});

		// Function to move the "applepay" payment method to the last position
		function sortPaymentMethods(paymentMethods: any[], showApplePayButton) {
			const filteredMethods = [];
			const regularPaymentMethod = paymentMethods.find(method => !['applepay', 'googlepay'].includes(method.type));
			const applePayMethod = paymentMethods.find(method => method.type === 'applepay');
			const googlePayMethod = paymentMethods.find(method => method.type === 'googlepay');

			// We want the apple pay option being first
			if (applePayMethod && showApplePayButton) {
				filteredMethods.push(applePayMethod);
			}
			// Second of all we want the google method
			if (googlePayMethod) {
				filteredMethods.push(googlePayMethod);
			}
			// Finally we want the regular cc option to appear
			if (regularPaymentMethod) {
				filteredMethods.push(regularPaymentMethod);
			}

			return filteredMethods;
		}
	}

	showNabEPXDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(NavepxDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				data: { redirectURL: args.url, providerData: args.providerData },
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve({ data: result.data });
						break;
					case "error":
						reject({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: this.appService.translate("SERVER_MESSAGES.CREDIT_GUARD_EX_ERROR"),
							serverError: {}
						});
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	magensaSDKLoaded: boolean = false;
	async showMagensaDialog(parsedPayment, args) {

		if (!this.magensaSDKLoaded) {
			await Promise.all([
				this.appService.loadScript('https://cdn.magensa.net/te-connect/1.3.4/te-connect.js'),
				this.appService.loadScript('https://cdn.magensa.net/te-connect-js/1.3.1/te-connect-js.js')
			])
			this.magensaSDKLoaded = true;
		}

		const $storage = this.appService.$storage;
		const account = _.find($storage.paymentAccounts, { _id: parsedPayment.account });
		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(MagensaPayDialogComponent, {
				panelClass: 'full',
				direction: this.appService.direction,
				maxWidth: '100vw',
				maxHeight: '100vh',
				data: {
					parsedPayment: parsedPayment,
					account: account,
					args: args,
					total: parsedPayment.amount / 100,
				},
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				let mode = _.get(result, 'mode');
				switch (mode) {
					case "success":
						resolve(result.data);
						break;
					case "error":
						reject({
							type: 'PAYMENT_VALIDATION_ERROR',
							message: this.appService.translate("SERVER_MESSAGES.CREDIT_GUARD_EX_ERROR"),
							serverError: {}
						});
						break;
					default:
						reject({ type: "CANCELED" });
				}
			});
		});
	}

	//------------------------------------------------------------------->
    // Braintree
	//------------------------------------------------------------------->

	async initBraintree(account, amount) {
		this.appService.startBlock();
		let res;
		try {
			res = await this.entityService.servicePost({
				url: `/online-shopper/finance/BraintreeAccounts/${account._id}/sdk-configuration`,
				data: { amount: this.decimalPipe.transform(amount, '2.2-2') }
			})
		} catch (err) {
			this.appService.alert({ content: 'error_general' });
			this.appService.stopBlock();
			throw (err);
		}

		account.clientToken = account.clientToken;
		this.appService.stopBlock();

		return this.showBraintreeDialog({
			clientToken: res["clientToken"],
			configuration: res["clientConfiguration"],
			total: amount
		}).then(res => {
			if (res) return res;
		}).catch(err => {
			throw (err);
		});

	}

	public showBraintreeDialog(args) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(BraintreeDialogComponent, {
				width: "400px",
				maxWidth: "95vw",
				panelClass: 'rounded-dialog',
				disableClose: true,
				closeOnNavigation: false,
				hasBackdrop: true,

				direction: this.appService.direction,
				data: args,
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				//this.appService.alert({ content: JSON.stringify(result) }).then(() => {
				if (result) {
					resolve(result);
				} else {
					resolve(null);
				}
				//});
			});
		});
	}

	//------------------------------------------------------------------->
    // NATIVE PAYMENT (Apple/Google Pay)
	//------------------------------------------------------------------->

	walletScriptsLoaded: boolean;
	public async initMobileWalletScripts(): Promise<any> {
		if (this.walletScriptsLoaded) return;
		this.walletScriptsLoaded = true;
		return Promise.all([
			this.appService.loadScript('https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js'),
			this.appService.loadScript('https://pay.google.com/gp/p/js/pay.js')
		]);
    }

    public showNativePaymentButtons($storage) {
		let config = $storage.config || $storage.rosConfig?.config
		if (config) {
			const enableNativePayments = _.get(config, 'settings.enableNativePayments', false);
			const showButtons = ['IL'].includes(this.appService.region) && enableNativePayments;
			return showButtons;
		}

    }

    public getAppleValidation(): Promise<any> {
        return new Promise((resolve, reject) => {
            return this.http.post<{}>(`${this.appConfig.tabitBridge}/finance/apple/get-session-verification`, {
				domainName: window.location.host || window.location.hostname,
			}).subscribe(
				(response: any) => {
					resolve(response);
				},
				(err) => {
					reject(err)
				}
			);
		});
    }

    public initApplePaymentRequest(paymentData) {
        return new Promise((resolve, reject) => {
            if (!paymentData.amount) reject('No payment to process');

            // Create an instance of ApplePaySession
            const paymentRequest: ApplePayPaymentRequest = {
                countryCode: this.appConfig.countryCode,
                currencyCode: this.appConfig.currencyCode,
                merchantCapabilities: ['supports3DS'],
                supportedNetworks: ['visa', 'masterCard', 'amex'],
                total: {
                    label: paymentData.$storage?.site?.name || 'Tabit',
                    type: 'final',
                    amount: paymentData.amount,
                },
            };

            const session = new ApplePaySession(1, paymentRequest);
            // Begin the Apple Pay session
            session.begin();

            this.getAppleValidation()
            .then(validation => {
                const { displayName, merchantSessionIdentifier } = validation;
                if (displayName && merchantSessionIdentifier) {
                    session.completeMerchantValidation(validation);
                } else {
                    session.abort();
                    reject(`getAppleValidation returned error: ${JSON.stringify(validation)}`)
                }

                session.onpaymentauthorized = (event) => {
                    let validationStatus;
                    if (event?.payment?.token) {
                        // console.log('=== onpaymentauthorized ===', event?.payment?.token);
                        validationStatus = ApplePaySession.STATUS_SUCCESS;
                    } else {
                        validationStatus = ApplePaySession.STATUS_FAILURE;
                    }
                    // Finalize the payment (STATUS_SUCCESS/STATUS_FAILURE)
                    session.completePayment(validationStatus);

                    switch(validationStatus) {
                        case ApplePaySession.STATUS_SUCCESS:
                            resolve(event?.payment?.token);
                        case ApplePaySession.STATUS_FAILURE:
                            reject('Paymend not authorized');
                    }
                };

                session.oncancel = (event) => {
                    reject(`Session canceled`);
                    console.log('=== oncancel ===', event);
                  // Handle the user's cancellation and call session.abort
                };
            });
        })
    }

    public appendGooglePayButton(className: string) {
        this.paymentsClient = new google.payments.api.PaymentsClient({ environment: this.appService.appConfig.isDev ? 'TEST' : 'PRODUCTION' });
        // Code that uses the `google` object
        const isReadyToPayRequest: any = Object.assign({}, baseRequest);
        isReadyToPayRequest.allowedPaymentMethods = [baseCardPaymentMethod];
        this.paymentsClient.isReadyToPay(isReadyToPayRequest)
        .then(response => {
            if (response.result) {
                appendGooglePayButton(this.paymentsClient);
            // add a Google Pay payment button
            }
        }).catch(err => {
            // show error in developer console for debugging
            console.error(err);
            return Promise.reject(err);
        });

        const appendGooglePayButton = (paymentsClient: any) => {
            const googlePayButton = paymentsClient.createButton({
                buttonColor: 'white',
                buttonType: 'plain',
                buttonSizeMode: 'fill',
                onClick: () => { },
                allowedPaymentMethods: []
            });
            // console.log(googlePayButton);
            $(document).ready(() => {
                $(className).append(googlePayButton);
            });
        };
    }

    public initGooglePayPayment(paymentData) {
        if (!paymentData.amount) throw 'No payment to process';
        const gatewayMerchantId = _.get(paymentData, 'account.merchantNumber', '0882819014');
        const tokenizationSpecification = {
            type: 'PAYMENT_GATEWAY',
            parameters: {
                'gateway': 'hyp',
                'gatewayMerchantId': gatewayMerchantId
            }
        };

        const cardPaymentMethod = Object.assign({ tokenizationSpecification }, baseCardPaymentMethod );

        const paymentDataRequest: any = Object.assign({}, baseRequest);
        const totalPrice = paymentData.amount.toString();

        paymentDataRequest.transactionInfo = {
            totalPriceStatus: 'FINAL',
            totalPrice,
            currencyCode: this.appConfig.currencyCode,
            countryCode: this.appConfig.countryCode,
        };

        const merchantId = this.appService.appConfig.isDev ? gatewayMerchantId : 'BCR2DN4TRLGLT4I2';
        paymentDataRequest.merchantInfo = {
            merchantName: paymentData.$storage?.site?.name || 'Tabit',
            merchantId
        };

        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];

        return this.paymentsClient.loadPaymentData(paymentDataRequest)
        .then(paymentData => {
            if (!paymentData.paymentMethodData?.tokenizationData?.token) throw 'No token received';
            // if using gateway tokenization, pass this token without modification
            const paymentToken = paymentData.paymentMethodData?.tokenizationData?.token;
            return paymentToken;
        }).catch(err => {
            // show error in developer console for debugging
            console.error(err);
            throw err;
        });
    }

    public handleNativePaymentError() {
        return this.appService.alert({ content: 'NATIVE_PAYMENT.error_dialog_title' });
    }
}
